var path = '/app/components/dealer-dropdown.component.html';
var html = " <select class=\"dealer-dropdown-style form-control\" ng-model=\"$ctrl.selectedDealerId\" ng-change=\"$ctrl.changeEventWrapper()\" ng-options=\"dealer.id as dealer.name for dealer in $ctrl.dealers\"> </select> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;